export const AnalyticsOrigin = {
  CoachRecommendation: 'coach_recommendation',
  MultipleJobs: 'multiple_jobs',
  MultipleInstitutions: 'multiple_institutions',
  Collection: 'collection',
  ActivityOverview: 'activity_overview',
  Completion: 'completion',
  Library: 'library',
  Wallet: 'wallet',
  PublicBrowse: 'public_browse',
  Carousel: 'carousel',
  DirectLink: 'direct_link',
  SavedItems: 'saved_items',
  SavedPage: 'saved_page',
  JobActivity: 'job_activity',
  JobOverview: 'job_overview',
  InstitutionActivity: 'institution_activity',
  InstitutionOverview: 'institution_overview',
  InstitutionGrid: 'institution_grid',
  InstitutionDirectory: 'institution_directory',
  ExploreIndex: 'explore',
  IndustryActivity: 'industry_activity',
  StoryActivity: 'story_activity',
  Topics: 'topics',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type AnalyticsOrigin = (typeof AnalyticsOrigin)[keyof typeof AnalyticsOrigin];

/**
 * Which mount of an institution profile sent `UNIFIED_INSTITUTION_VIEWED`. Both roll up to one
 * figure per institution, so the two names have to agree across the call sites that send them.
 */
export const InstitutionViewSurface = {
  Activity: 'activity',
  PublicProfile: 'public_profile',
} as const;
// eslint-disable-next-line ts/no-redeclare
export type InstitutionViewSurface = (typeof InstitutionViewSurface)[keyof typeof InstitutionViewSurface];
